<template>
  <div class="k-line-chart-container">
    <div id="technical-indicator-k-line" class="k-line-chart"></div>
    <div class="k-line-chart-menu-container">
      <!-- <span style="padding-right: 10px">Indicadores do gráfico principal</span>
      <button
        v-for="type in mainTechnicalIndicatorTypes"
        :key="type"
        @click="setCandleTechnicalIndicator(type)"
      >
        {{ type }}
      </button>
      <span style="padding-right: 10px; padding-left: 12px"
        >Indicador de submapa</span
      >

      <button
        v-for="type in subTechnicalIndicatorTypes"
        :key="type"
        @click="setSubTechnicalIndicator(type)"
      >
        {{ type }}
      </button> -->
      <!-- /////////////////////////////////////////// -->
      <button
        v-for="{ key, text } in shapes"
        :key="key"
        v-on:click="setShapeType(key)"
      >
        {{ text }}
      </button>
      <button v-on:click="removeAllShape()">Clear</button>
    </div>
  </div>
</template>

<script>
import { dispose, init } from "klinecharts";
import { checkCoordinateOnSegment } from "klinecharts/lib/shape/shapeHelper";
import moment from "moment";
import Layout from "./Layout";

const icon =
  "https://bluetoken.io/app/blue_icon_main.png?3284ebff7df94f792898c67564230ad0";

// custom indicator
const emojiTechnicalIndicator = {
  name: "BLUE",
  plots: [{ key: "BLUE" }],
  calcTechnicalIndicator: (kLineDataList) => {
    const result = [];
    kLineDataList.forEach((kLineData) => {
      result.push({
        close: kLineData.close,
        icon: icon,
      });
    });
    return result;
  },
  render: ({ ctx, dataSource, viewport, xAxis, yAxis }) => {
    ctx.font = `${viewport.barSpace}px Helvetica Neue`;
    ctx.textAlign = "center";
    for (let i = dataSource.from; i < dataSource.to; i++) {
      const data = dataSource.technicalIndicatorDataList[i];
      const x = xAxis.convertToPixel(i);
      const y = yAxis.convertToPixel(data.close);
      let dataPrice = new Image(15, 20);
      dataPrice.src = icon;
      ctx.drawImage(dataPrice, x, y, dataPrice.width, dataPrice.height);
    }
  },
};

const rect = {
  name: "rect",
  totalStep: 3,
  checkEventCoordinateOnShape: ({ dataSource, eventCoordinate }) => {
    return checkCoordinateOnSegment(
      dataSource[0],
      dataSource[1],
      eventCoordinate
    );
  },
  createShapeDataSource: ({ coordinates }) => {
    if (coordinates.length === 2) {
      return [
        {
          type: "line",
          isDraw: false,
          isCheck: true,
          dataSource: [
            [
              { ...coordinates[0] },
              { x: coordinates[1].x, y: coordinates[0].y },
            ],
            [
              { x: coordinates[1].x, y: coordinates[0].y },
              { ...coordinates[1] },
            ],
            [
              { ...coordinates[1] },
              { x: coordinates[0].x, y: coordinates[1].y },
            ],
            [
              { x: coordinates[0].x, y: coordinates[1].y },
              { ...coordinates[0] },
            ],
          ],
        },
        {
          type: "polygon",
          isDraw: true,
          isCheck: false,
          styles: { style: "fill" },
          dataSource: [
            [
              { ...coordinates[0] },
              { x: coordinates[1].x, y: coordinates[0].y },
              { ...coordinates[1] },
              { x: coordinates[0].x, y: coordinates[1].y },
            ],
          ],
        },
        {
          type: "polygon",
          isDraw: true,
          isCheck: false,
          dataSource: [
            [
              { ...coordinates[0] },
              { x: coordinates[1].x, y: coordinates[0].y },
              { ...coordinates[1] },
              { x: coordinates[0].x, y: coordinates[1].y },
            ],
          ],
        },
      ];
    }
    return [];
  },
};

const circle = {
  name: "circle",
  totalStep: 3,
  checkEventCoordinateOnShape: ({ dataSource, eventCoordinate }) => {
    const xDis = Math.abs(dataSource.x - eventCoordinate.x);
    const yDis = Math.abs(dataSource.y - eventCoordinate.y);
    const r = Math.sqrt(xDis * xDis + yDis * yDis);
    return Math.abs(r - dataSource.radius) < 3;
  },
  createShapeDataSource: ({ coordinates }) => {
    if (coordinates.length === 2) {
      const xDis = Math.abs(coordinates[0].x - coordinates[1].x);
      const yDis = Math.abs(coordinates[0].y - coordinates[1].y);
      const radius = Math.sqrt(xDis * xDis + yDis * yDis);
      return [
        {
          type: "arc",
          isDraw: true,
          isCheck: false,
          styles: { style: "fill" },
          dataSource: [
            { ...coordinates[0], radius, startAngle: 0, endAngle: Math.PI * 2 },
          ],
        },
        {
          type: "arc",
          isDraw: true,
          isCheck: true,
          dataSource: [
            { ...coordinates[0], radius, startAngle: 0, endAngle: Math.PI * 2 },
          ],
        },
      ];
    }
    return [];
  },
};

export default {
  props: ["chartData"],
  name: "TechnicalIndicatorKLineChart",
  components: { Layout },
  created() {
    this.getDataPrice();
  },

  data: function () {
    return {
      dataPrice: [],
      mainTechnicalIndicatorTypes: ["MA", "EMA", "SAR"],
      subTechnicalIndicatorTypes: ["VOL", "MACD", "KDJ"],
      shapes: [
        { key: "priceLine", text: "Price line" },
        { key: "priceChannelLine", text: "Price channel line" },
        { key: "parallelStraightLine", text: "Parallel lines" },
        { key: "fibonacciLine", text: "Fibonacci" },
        { key: "rect", text: "Rectangle" },
        { key: "circle", text: "Circle" },
      ],
    };
  },
  mounted: function () {
    this.kLineChart = init("technical-indicator-k-line", {
      candle: {
        tooltip: {
          labels: [
            "time: ",
            "open: ",
            "receive: ",
            "high: ",
            "low: ",
            "volume: ",
          ],
        },
      },
    });

    this.kLineChart.applyNewData(this.dataPrice);

    ////////////////////////////////////////////////////////////////////////////////emoji
    // this.kLineChart.addTechnicalIndicatorTemplate(emojiTechnicalIndicator);
    // this.paneId = this.kLineChart.createTechnicalIndicator("VOL", false);
    ////////////////////////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////////////////////draw
    this.kLineChart.addShapeTemplate([rect, circle]);
    this.kLineChart.applyNewData(generatedKLineDataList());
    ////////////////////////////////////////////////////////////////////////////////
  },
  methods: {
    getDataPrice: function () {
      this.dataPrice = this.chartData.map((item) => ({
        timestamp: moment(item.at).valueOf(),
        close: item.close,
        open: item.open,
        low: item.min,
        high: item.max,
      }));
    },

    // setCandleTechnicalIndicator: function (type) {
    //   this.kLineChart.createTechnicalIndicator(type, false, {
    //     id: "candle_pane",
    //   });
    // },
    // setSubTechnicalIndicator: function (type) {
    //   this.kLineChart.createTechnicalIndicator(type, false, {
    //     id: this.paneId,
    //   });
    // },

    setShapeType: function (shapeName) {
      this.kLineChart.createShape(shapeName);
    },
    removeAllShape() {
      this.kLineChart.removeShape();
    },
  },
  destroyed: function () {
    // dispose("technical-indicator-k-line");
    dispose("draw-shape-k-line");
  },
};
</script>

<style lang="scss">
.k-line-chart-container {
  display: flex;
  flex-direction: column;
  margin: auto;
  border-radius: 2px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  background-color: #ffffff;
  width: 900px;
  height: 520px;
  padding: 1rem 0.5rem;

  @media screen and (max-width: 600px) {
    width: 98%;
    padding: 0;
    // padding: 1rem 0.5rem;
  }
}
.k-line-chart-title {
  margin: 0;
  color: #252525;
  padding-bottom: 10px;
}
.k-line-chart {
  display: flex;
  flex: 1;
}
.k-line-chart-menu-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
  font-size: 12px;
  color: #606060;
}
.k-line-chart-menu-container button {
  cursor: pointer;
  background-color: #342365;
  border-radius: 4px;
  margin-right: 8px;
  height: 24px;
  line-height: 26px;
  padding: 0px 6px;
  font-size: 12px;
  color: #fff;
  border: none;
  outline: none;
}
</style>


// WEBPACK FOOTER //
// src/components/public/charts_component/TradeChart.vue